var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.071 7.05011C18.8835 6.86264 18.6292 6.75732 18.364 6.75732C18.0989 6.75732 17.8446 6.86264 17.657 7.05011L9.87903 14.8281L6.34303 11.2931C6.15443 11.111 5.90182 11.0102 5.63963 11.0124C5.37743 11.0147 5.12662 11.1199 4.94121 11.3053C4.7558 11.4907 4.65063 11.7415 4.64835 12.0037C4.64607 12.2659 4.74687 12.5185 4.92903 12.7071L9.17203 16.9501C9.35955 17.1376 9.61386 17.2429 9.87903 17.2429C10.1442 17.2429 10.3985 17.1376 10.586 16.9501L19.071 8.46411C19.2585 8.27658 19.3638 8.02227 19.3638 7.75711C19.3638 7.49195 19.2585 7.23764 19.071 7.05011V7.05011Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.19ceab3541a7bae09c03061bf15147e6.svg";
export { ForwardRef as ReactComponent };